export default __webpack_public_path__ + "static/media/section36.051277f4.svg";